<template>
  <div class="custom-page-card">
    <div class="custom-page-card__container">
      <div class="custom-page-card__actions">
        <div v-if="info.langs.length">
          <a-select
            :value="selectedLanguage"
            size="small"
            @change="handleLangChange"
            class="lang-select"
          >
            <a-select-option v-for="lang in langOptions" :key="lang.value">
              {{ lang.name }}
            </a-select-option>
          </a-select>
        </div>
        <a-button
          type="link"
          size="small"
          :disabled="!editPermission"
          @click="openEditPage"
        >
          <a-icon type="edit" class="text-primary font-size-16" />
          Edit
        </a-button>
      </div>
      <div class="custom-page-card__content" @click="openFullInfoModal">
        <div class="custom-page-card__image">
          <img v-if="currentPreviewImage" :src="currentPreviewImage" alt="Background image">
          <div v-else class="custom-page-card__no-image">
            <img src="/resources/images/empty/no-image.svg" alt="No image">
            <span>No Image</span>
          </div>
          <div class="custom-page-card__badges">
            <span v-if="info.is_draft" class="custom-page-card__badge custom-page-card__badge--draft">
              Draft
            </span>
            <span v-if="info.is_publish" class="custom-page-card__badge custom-page-card__badge--published">
              Published
            </span>
            <span v-else class="custom-page-card__badge custom-page-card__badge--draft">
              Unpublished
            </span>
          </div>
        </div>
        <ul class="custom-page-card__props">
          <li class="custom-page-card__prop">
            <span class="custom-page-card__prop--label">
              Name for internal usage
            </span>
            <span class="custom-page-card__prop--value">{{ info.name }}</span>
          </li>

          <li class="custom-page-card__prop">
            <span class="custom-page-card__prop--label">Apps</span>
            <span class="custom-page-card__prop--value">
              <a-tag v-for="app in info.applications.slice(0, 2)" :key="app.id">
                {{ app.name }}
                <a-icon
                  v-if="app.platform.toLowerCase() === 'android'"
                  type="android"
                  class="ml-1 text-success"
                />
                <a-icon
                  v-if="app.platform.toLowerCase() === 'ios'"
                  type="apple"
                  class="ml-1 text-primary"
                />
                <a-icon
                  v-if="app.platform.toLowerCase() === 'web'"
                  type="global"
                  class="ml-1 text-default"
                />
              </a-tag>
              <a-tag v-if="info.applications.length > 2"> ... </a-tag>
            </span>
          </li>
        </ul>
      </div>
      <div class="custom-page-card__footer">
        <div class="custom-page-card__date">
          {{ formatDate(info.period.starts_at) }} -
          <span v-if="info.period.ends_at">
            {{ formatDate(info.period.ends_at) }}
          </span>
          <span v-else style="font-size: 20px">&infin;</span>
        </div>
        <a-switch
          :checked="info.is_active"
          @change="(val) => $emit('changeActive', val, info.uuid)"
          :disabled="!editPermission"
        />
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import 'dayjs/locale/ru'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru')

export default {
  props: {
    info: {
      type: Object,
    },
    editPermission: {
      type: Boolean,
    },
    languages: {
      type: Array,
    },
  },
  data: () => ({
    selectedLanguage: 'ru',
  }),
  computed: {
    langOptions() {
      const langIds = this.info.langs.map((l) => l.lid)

      return this.languages
        .filter((language) => langIds.includes(language.id))
        .map((language) => ({
          name: language.desc,
          value: language.name,
        }))
    },
    selectedLanguageId() {
      return this.languages.find((l) => l.name === this.selectedLanguage)?.id
    },
    selectedPreview() {
      return this.info.langs.find((l) => l.lid === this.selectedLanguageId)
    },
    currentPreviewImage() {
      return this.info.header?.langs?.find(lang => lang.lid === this.selectedLanguageId)?.banner_background_path ?? null
    },
  },
  methods: {
    openFullInfoModal() {
      this.$emit('openFullInfo')
    },
    openEditPage() {
      this.$emit('openEdit')
    },
    formatDate: function (date) {
      return this.$moment.utc(date).format('DD.MM.YYYY HH:mm')
    },
    handleLangChange(selectedLangKey) {
      this.selectedLanguage = selectedLangKey
    },
  },
}
</script>
<style lang="scss" src="./style.module.scss" />
